

































import { Component, Vue } from 'vue-property-decorator'
import PageHeader from '@/components/PageHeaderComponent.vue'
import downloadAppFunc from '@/shared/functions/downloadAppFunc'
import ButtonComponent from '@/components/buttons/ButtonComponent.vue'
import store from '@/store/store'

@Component({
  components: {
    PageHeader,
    ButtonComponent
  }
})

export default class DownloadAppPage extends Vue {
  public isDesktop = false
  private webCheckIn: any
  public productType = ''

  private created () {
    this.isDesktop = downloadAppFunc.checkIfDesktop()
    this.webCheckIn = store.getHotelInfo()
    if (this.webCheckIn.ProductType) {
      this.productType = this.webCheckIn.productType
    }
  }

  public async checkOS () {
    await downloadAppFunc.checkOS()
  }
}
